import axiosInstance from '../../interceptors/axiosInstance';
import PermisoDto from '../../dtos/permisoDto';
import { ListResponseDto } from '../../dtos/ListResponseDto';

/**
 * Obtiene los permisos según los roles del usuario
 * @param roles - Array de roles del usuario
 * @returns Array de PermisoDto
 */
export async function obtenerPermisosPorRol(roles: string[]): Promise<PermisoDto[]> {
    try {
        if (!roles || roles.length === 0) {
            console.warn('No se proporcionaron roles para obtener permisos');
            return [];
        }

        console.log('🔐 Obteniendo permisos para roles:', roles);
        
        const url = `siscred-api-transversal/v1/authpermisos/obtener-permisos-por-rol`;
        const params = { items: roles };
        const response = await axiosInstance.post<ListResponseDto<PermisoDto>>(url, params, {
            headers: {
                'X-Hide-Loader': 'true', // No mostrar loader en esta llamada silenciosa
                'X-Hide-Toast': 'true'   // No mostrar toast en esta llamada silenciosa
            }
        });
        
        console.log('✅ Permisos obtenidos:', response.data.items);
        return response.data.items;
    } catch (error) {
        console.error('❌ Error al obtener permisos por rol:', error);
        return [];
    }
}

/**
 * Obtiene los permisos según un solo rol
 * @param rol - Rol del usuario
 * @returns Array de PermisoDto
 */
export async function obtenerPermisosPorRolUnico(rol: string): Promise<PermisoDto[]> {
    return obtenerPermisosPorRol([rol]);
}

